import { z } from 'zod';
import { GOVERNMENT_APPLICATION_CONFIRMATION_BULK_OPERATIONS, GOVERNMENT_APPLICATION_CONFIRMATION_DEFAULT_PAGE_SIZE, GOVERNMENT_APPLICATION_CONFIRMATION_ORDER_BY, GOVERNMENT_APPLICATION_CONFIRMATION_UNIFIED_STATUSES } from './-constants';
const unifiedStatusSchema = z.enum(GOVERNMENT_APPLICATION_CONFIRMATION_UNIFIED_STATUSES);
const orderBySchema = z.enum(GOVERNMENT_APPLICATION_CONFIRMATION_ORDER_BY);
const bulkOperationSchema = z.enum(GOVERNMENT_APPLICATION_CONFIRMATION_BULK_OPERATIONS);
export const GovernmentApplicationConfirmationSearchSchema = z.object({
  operationPackageId: z.string().min(1),
  operationPackagePatternId: z.string().min(1),
  pageIndex: z.number().int().nonnegative().catch(0),
  pageSize: z.number().int().positive().max(2000).catch(GOVERNMENT_APPLICATION_CONFIRMATION_DEFAULT_PAGE_SIZE),
  tagId: z.string().min(1),
  orderBy: orderBySchema.optional().catch(undefined),
  orderDirection: z.enum(['asc', 'desc']).optional().catch(undefined),
  searchText: z.string().max(500).optional().catch(undefined),
  status: z.array(unifiedStatusSchema).optional().catch(undefined),
  bulkOperation: bulkOperationSchema.optional().catch(undefined)
});